// extracted by mini-css-extract-plugin
export default {"period_button_block":"styled_period_button_block__g6Pho","period_statistic_button":"styled_period_statistic_button__rTHVx","modal_close_button":"styled_modal_close_button__-0kFz"};